const swiperHeroDesktop = new Swiper('.swiper.swiper-hero-desktop', {
    direction: "horizontal",
    pagination: {
        el: ".swiper-pagination",
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        990: {
            slidesPerView: 1,
            enabled: true
        },
    }
})

const swiperHeroMobile = new Swiper('.swiper.swiper-hero-mobile', {
    direction: "horizontal",
    pagination: {
        el: ".swiper-pagination",
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        650: {
            slidesPerView: 1
        },
    }
})